/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { WhiteCard } from "../../../components/StyledComponents";

import * as breakpoint from '../../../styles/breakpoints.module.scss';


const IntroductionSection = (props) => {

  const {children, narrow } = props;
  return(
    <div css={css`
      position:relative;z-index:3;padding-bottom:48px;
      @media only screen and (max-width: ${breakpoint.smMax}){
        padding:0 80px 32px;
      }

      @media only screen and (max-width: ${breakpoint.xsMax}){
        padding:0 24px 32px;
      }
    
    `} {...props}>
      <WhiteCard narrow={narrow}>
        {children}
      </WhiteCard>
    </div>
  );
};

export default IntroductionSection;
